import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { Events } from 'ionic-angular';
import * as moment from 'moment';

@Injectable()
export class DataServiceProvider {
  public data: any;
  public auth: any;
  public types: any = {};
  public feedings: any[] = [];
  public diapers: any[] = [];
  public latestFeeding: any;
  public latestDiaper: any;
  public standardType: any = 'formula';
  public mealsSummary: any;

  public user: any;

  constructor(public events: Events) {
    this.types = this.getStandardTypes();
    this.data = firebase.database().ref('/data/');
    this.auth = firebase.auth();

    this.auth.onAuthStateChanged((user: any) => {
      if (user) {
        // User
        this.user = user;

        // Last Feeding
        this.data
          .child(user.uid)
          .child('latestFeeding')
          .on('value', (data: any) => {
            let latestFeeding = data.val();
            if (latestFeeding) {
              let millis =
                moment().valueOf() - moment(latestFeeding.timestamp).valueOf();
              latestFeeding.hours = moment(millis)
                .utc()
                .hours();
              latestFeeding.minutes = moment(millis).minutes();
              this.latestFeeding = latestFeeding;
              this.events.publish('updateScreen');
            }
          });
        // Last Diaper
        this.data
          .child(user.uid)
          .child('latestDiaper')
          .on('value', (data: any) => {
            let latestDiaper = data.val();

            if (latestDiaper) {
              let millis =
                moment().valueOf() - moment(latestDiaper.timestamp).valueOf();
              latestDiaper.hours = moment(millis)
                .utc()
                .hours();
              latestDiaper.minutes = moment(millis).minutes();
              this.latestDiaper = latestDiaper;
              this.events.publish('updateScreen');
            }
          });

        this.data
          .child(user.uid)
          .child('feedings')
          .limitToLast(100)
          .on('value', (data: any) => {
            this.feedings = [];
            data.forEach(child => {
              this.feedings.push(child.val());
              console.log(child.val());
            });
            this.feedings = this.feedings.sort((a, b) => {
              return a.timestamp > b.timestamp
                ? -1
                : a.timestamp < b.timestamp
                ? 1
                : 0;
            });
            this.updateSummary();
            this.events.publish('updateScreen');
          });

        this.data
          .child(user.uid)
          .child('diapers')
          .limitToLast(100)
          .on('value', (data: any) => {
            this.diapers = [];
            data.forEach(child => {
              this.diapers.push(child.val());
            });
            this.diapers = this.diapers.sort((a, b) => {
              return a.timestamp > b.timestamp
                ? -1
                : a.timestamp < b.timestamp
                ? 1
                : 0;
            });
          });

        this.data
          .child(user.uid)
          .child('types')
          .on('value', (data: any) => {
            if (data.val()) {
              data.forEach(child => {
                this.types[child.key].maxRange = child.val().maxRange;
              });
            }
          });

        this.data
          .child(user.uid)
          .child('standardType')
          .on('value', (data: any) => {
            if (data.val()) {
              this.standardType = data.val();
            }
          });

        /* 
        // Feedings
        this.data.child(this.user.uid).child("feedings").on("child_added", (data:any) => {
          this.feedings.push(data.val());
          this.feedings = this.feedings.sort((a, b) => {
            return (a.timestamp > b.timestamp) ? -1 : ((a.timestamp < b.timestamp) ? 1 : 0);
          })
          this.updateSummary();
          //this.events.publish('lastFeeding',this.feedings[0]);
        });
        this.data.child(this.user.uid).child("feedings").on("child_changed", (data:any) => {
          for(var i = 0; i < this.feedings.length; i++){
            if (this.feedings[i].uid == data.key){
              this.feedings.splice(i,1);
            }
          }
          this.feedings.push(data.val());
          this.feedings = this.feedings.sort((a, b) => {
            return (a.timestamp > b.timestamp) ? -1 : ((a.timestamp < b.timestamp) ? 1 : 0);
          })
          this.updateSummary();
          //this.events.publish('lastFeeding',this.feedings[0]);
        });
        this.data.child(this.user.uid).child("feedings").on("child_removed", (data:any) => {
          for(var i = 0; i < this.feedings.length; i++){
            if (this.feedings[i].uid == data.key){
              this.feedings.splice(i,1);
            }
          }
          this.updateSummary();
          //this.events.publish('lastFeeding',this.feedings[0]);
        });

        // Diapers
        this.data.child(this.user.uid).child("diapers").on("child_added", (data:any) => {
          if(!data.val().uid){
            return
          }
          this.diapers.push(data.val());
          this.diapers = this.diapers.sort((a, b) => {
            return (a.timestamp > b.timestamp) ? -1 : ((a.timestamp < b.timestamp) ? 1 : 0);
          })
          //this.events.publish('lastDiaper',this.diapers[0]);
        });
        this.data.child(this.user.uid).child("diapers").on("child_changed", (data:any) => {
          for(var i = 0; i < this.diapers.length; i++){
            if (this.diapers[i].uid == data.key){
              this.diapers.splice(i,1);
            }
          }
          this.diapers.push(data.val());
          this.diapers = this.diapers.sort((a, b) => {
            return (a.timestamp > b.timestamp) ? -1 : ((a.timestamp < b.timestamp) ? 1 : 0);
          })
          //this.events.publish('lastDiaper',this.diapers[0]);
        });
        this.data.child(this.user.uid).child("diapers").on("child_removed", (data:any) => {
          for(var i = 0; i < this.diapers.length; i++){
            if (this.diapers[i].uid == data.key){
              this.diapers.splice(i,1);
            }
          }
          //this.events.publish('lastDiaper',this.diapers[0]);
        }); */
      } else {
        this.user = null;
        this.feedings = [];
        this.diapers = [];
      }
    });
  }

  updateSummary() {
    if (this.latestFeeding) {
      let millis =
        moment().valueOf() - moment(this.latestFeeding.timestamp).valueOf();
      this.latestFeeding.hours = moment(millis)
        .utc()
        .hours();
      this.latestFeeding.minutes = moment(millis).minutes();
    }

    if (this.latestDiaper) {
      let millis =
        moment().valueOf() - moment(this.latestDiaper.timestamp).valueOf();
      this.latestDiaper.hours = moment(millis)
        .utc()
        .hours();
      this.latestDiaper.minutes = moment(millis).minutes();
    }

    let mealsSummary = [];
    for (let type in this.types) {
      let meal = {
        type: type,
        sum: 0
      };
      mealsSummary.push(meal);
    }

    for (var i = 0; i < this.feedings.length; i++) {
      let millis =
        moment().valueOf() - moment(this.feedings[i].timestamp).valueOf();
      if (millis <= 86400000) {
        for (let meal of mealsSummary) {
          if (this.feedings[i].type == meal.type) {
            meal.sum += this.feedings[i].amount;
          }
        }
      }
    }
    this.mealsSummary = mealsSummary;
  }

  removeFeeding(feeding: any) {
    this.data
      .child(this.user.uid)
      .child('feedings')
      .child(feeding.uid)
      .remove();
  }

  removeDiaper(diaper: any) {
    this.data
      .child(this.user.uid)
      .child('diapers')
      .child(diaper.uid)
      .remove();
  }

  getAuth() {
    return this.auth;
  }

  login(userEmail: string, userPassword: string) {
    return new Promise((resolve, reject) => {
      this.auth
        .signInWithEmailAndPassword(userEmail, userPassword)
        .then((userData: any) => resolve(userData), (err: any) => reject(err));
    });
  }

  signUpWithEmail(userEmail: string, userPassword: string) {
    return new Promise((resolve, reject) => {
      this.auth
        .createUserWithEmailAndPassword(userEmail, userPassword)
        .then((userData: any) => resolve(userData), (err: any) => reject(err));
    });
  }

  setUserPassword(password: any) {
    return this.auth.currentUser.updatePassword(password);
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.auth
        .signOut()
        .then(() => resolve(true), (err: any) => reject(false));
    });
  }

  setTypes(types: any) {
    this.data
      .child(this.user.uid)
      .child('types')
      .set(types);
  }

  setStandardType(standardType: any) {
    this.data
      .child(this.user.uid)
      .child('standardType')
      .set(standardType);
  }

  getTypes() {
    return this.types;
  }

  getStandardTypes() {
    let types: any = {
      formula: {
        maxRange: 260,
        unit: 'ml',
        name: 'Säuglingsnahrung',
        icon: 'assets/images/bottle_cremewhite.png',
        index: 0
      },
      porridge: {
        maxRange: 200,
        unit: 'g',
        name: 'Brei',
        icon: 'assets/images/bowl.png',
        index: 1
      },
      tea: {
        maxRange: 200,
        unit: 'ml',
        name: 'Tee',
        icon: 'assets/images/bottle_green.png',
        index: 2
      },
      snack: {
        maxRange: 10,
        unit: 'Stück',
        name: 'Snacks',
        icon: 'assets/images/snacks.png',
        index: 3
      },
      fruits: {
        maxRange: 10,
        unit: 'Stück',
        name: 'Obst',
        icon: 'assets/images/fruits.png',
        index: 4
      },
      veggies: {
        maxRange: 10,
        unit: 'Stück',
        name: 'Gemüse',
        icon: 'assets/images/veggies.png',
        index: 5
      },
      water: {
        maxRange: 200,
        unit: 'ml',
        name: 'Wasser',
        icon: 'assets/images/bottle_blue.png',
        index: 6
      },
      juice: {
        maxRange: 200,
        unit: 'ml',
        name: 'Saft',
        icon: 'assets/images/bottle_pink.png',
        index: 7
      },
      breastMilk: {
        maxRange: 200,
        unit: 'ml',
        name: 'Muttermilch',
        icon: 'assets/images/bottle_yellow.png',
        index: 8
      },
      breastFeed: {
        maxRange: 60,
        unit: 'Min',
        name: 'Stillen',
        icon: 'assets/images/breastFeed.png',
        index: 9
      }
    };
    return types;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-service/data-service.ts